import { EntityAdapter } from '../adapters/interfaces/entity.adapter';
import { SortStrategy } from './interfaces/sort-strategy';

export class NoSortStrategy<T> implements SortStrategy<T> {
  public compare(left: T, right: T, adapter: EntityAdapter<T>): number {
    return 0;
  }
}
